"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _inherits = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var GetUserMediaError_1 = require("./GetUserMediaError");
var PermissionDeniedError = /*#__PURE__*/function (_GetUserMediaError_1$) {
  _inherits(PermissionDeniedError, _GetUserMediaError_1$);
  function PermissionDeniedError(cause, message) {
    var _this;
    _classCallCheck(this, PermissionDeniedError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(PermissionDeniedError).call(this, cause, message));
    _this.name = 'PermissionDeniedError';
    return _this;
  }
  return PermissionDeniedError;
}(GetUserMediaError_1.default);
exports.default = PermissionDeniedError;